import ctl from '@netlify/classnames-template-literals'
import { ReactNode } from 'react'

export interface TRowProps {
	children?: ReactNode
}

export function TRow({ children }: TRowProps) {
	const className = ctl(`
    group/row 
    divide-x 
    divide-grey-100
    dark:divide-grey-800
    hover:bg-neutral-100/50
    dark:hover:bg-grey-900/50
    `)

	return (
		<tr className={className}>
			{children}
		</tr>
	)
}

export interface TCellProps {
	children?: ReactNode
}

export function TCell({ children }: TCellProps) {
	return (
		<td className="whitespace-nowrap py-2 px-4 text-sm relative group">
			<div className="opacity-90 group-hover:opacity-100 relative inline-block w-full">
				{children}
			</div>
		</td>
	)
}
